// extracted by mini-css-extract-plugin
export default {"home":"c-i_cW","home__background":"c-i_cX","home__content":"c-i_cY"};